export default "__VITE_ASSET__Bn6Rc1GM__"